/**
 * Utilidades de moneda. Los montos se almacenan internamente en USD (base);
 * aquí se convierten y formatean a la moneda seleccionada (COP por defecto).
 */

export type Currency = 'COP' | 'USD';

/** Convierte un monto base (USD) a la moneda seleccionada. */
export const fromBaseUsd = (baseUsd: number, currency: Currency, rate: number): number => {
  const v = Number(baseUsd) || 0;
  return currency === 'COP' ? v * rate : v;
};

/** Convierte un monto ingresado en la moneda seleccionada de vuelta a base (USD). */
export const toBaseUsd = (amount: number, currency: Currency, rate: number): number => {
  const v = Number(amount) || 0;
  return currency === 'COP' && rate > 0 ? v / rate : v;
};

/** Formatea un monto base (USD) en la moneda seleccionada, con símbolo. */
export const formatMoney = (baseUsd: number | string, currency: Currency, rate: number): string => {
  const value = fromBaseUsd(Number(baseUsd) || 0, currency, rate);
  if (currency === 'COP') {
    return '$' + value.toLocaleString('es-CO', { maximumFractionDigits: 0 }) + ' COP';
  }
  return 'US$' + value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

/** Solo el número formateado (sin símbolo) — útil para inputs. */
export const formatAmount = (baseUsd: number | string, currency: Currency, rate: number): string => {
  const value = fromBaseUsd(Number(baseUsd) || 0, currency, rate);
  return currency === 'COP'
    ? value.toLocaleString('es-CO', { maximumFractionDigits: 0 })
    : value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

/** Etiqueta corta de la moneda actual (para labels). */
export const currencyLabel = (currency: Currency): string => (currency === 'COP' ? 'COP' : 'USD');
